import { Dispatch, SetStateAction, useMemo } from "react";
import styled from "styled-components";
import { Heading3 } from "../../components/Typography";
import { PAYMENT_METHOD_STRIPE } from "../../constants";
import { COLOR_WHITE } from "../../constants/colors";
import logoStripe from "../../images/logo-stripe.png";
import { PaymentImage, PaymentMethod } from "./shared";

const Container = styled(PaymentMethod)`
  background: linear-gradient(249.87deg, #3f3aa4 0%, #635bff 43.41%, #bbb7ff 104.52%);
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${COLOR_WHITE};
`;

const PaymentName = styled.div`
  ${Heading3}
`;

const PaymentNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

type Props = {
  setPaymentMethod: Dispatch<SetStateAction<string>>;
  selectedPayment: string;
};

export default function StripePaymentMethod({ setPaymentMethod, selectedPayment }: Props) {
  const isSelected = useMemo(() => {
    return selectedPayment === PAYMENT_METHOD_STRIPE;
  }, [selectedPayment]);

  return (
    <Container isSelected={isSelected} onClick={() => setPaymentMethod(PAYMENT_METHOD_STRIPE)}>
      <PaymentNameContainer>
        <PaymentImage src={logoStripe} alt="Ethereum" />
        <PaymentName>Stripe</PaymentName>
      </PaymentNameContainer>
    </Container>
  );
}
